import { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import Divider from 'antd/lib/divider';
import Empty from 'antd/lib/empty';

import News, { NewsShape } from '../News';

const NewsList = ({ news }) => (
    <>
        {news.map(item => (
            <Fragment key={item.id}>
                <News {...item} />
                <Divider />
            </Fragment>
        ))}
        {!news.length && <Empty />}
    </>
);

NewsList.propTypes = {
    news: PropTypes.arrayOf(NewsShape),
};

NewsList.defaultProps = {
    news: [],
};

export default NewsList;
